"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var DoubleCheck_exports = {};
__export(DoubleCheck_exports, {
  default: () => DoubleCheck_default
});
module.exports = __toCommonJS(DoubleCheck_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M18.625 7.00781C18.7161 6.90365 18.7617 6.78646 18.7617 6.65625C18.7617 6.51302 18.7096 6.39583 18.6055 6.30469C18.5013 6.21354 18.3776 6.16797 18.2344 6.16797C18.1042 6.16797 17.9935 6.22005 17.9023 6.32422L11.7109 12.8672L10.1484 11.4023L9.44531 12.125L11.3789 13.9414C11.431 13.9935 11.4831 14.0326 11.5352 14.0586C11.6003 14.0716 11.6719 14.0781 11.75 14.0781C11.8151 14.0781 11.8737 14.0651 11.9258 14.0391C11.9909 14.013 12.043 13.974 12.082 13.9219L18.625 7.00781ZM13 7.00781C13.0911 6.90365 13.1302 6.78646 13.1172 6.65625C13.1172 6.51302 13.0716 6.39583 12.9805 6.30469C12.8763 6.21354 12.7526 6.16797 12.6094 6.16797C12.4792 6.16797 12.3685 6.22005 12.2773 6.32422L6.08594 12.8672L3.11719 9.78125C3.01302 9.67708 2.88932 9.625 2.74609 9.625C2.61589 9.625 2.4987 9.67057 2.39453 9.76172C2.30339 9.86589 2.2513 9.98958 2.23828 10.1328C2.23828 10.263 2.29036 10.3737 2.39453 10.4648L5.73438 13.9219C5.78646 13.974 5.83854 14.013 5.89062 14.0391C5.95573 14.0651 6.02734 14.0781 6.10547 14.0781C6.17057 14.0781 6.22917 14.0651 6.28125 14.0391C6.34635 14.013 6.40495 13.974 6.45703 13.9219L13 7.00781Z",
      fill: "currentColor"
    }
  )
);
const SvgDoubleCheck = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var DoubleCheck_default = SvgDoubleCheck;
